import { useQuery } from '@apollo/client'
import { Alert } from 'antd'
import type React from 'react'

import type { AnnouncementPageKey } from '../../config/announcementPageKeys'
import { AnnouncementsDocument } from '../../generated/graphql'
import { MarkdownContent } from './MarkdownContent'

type Props = {
  pageKeys: readonly AnnouncementPageKey[]
}

// お知らせを現在のページに表示するかどうかを判定する
// お知らせ側のキーが空の場合は全ページが対象
// targetPageKeys は GraphQL 上 String で返る（Rails 側のページ構成変更で値が古くなっても
// クエリ全体が壊れないようにするため）ため、未知の文字列が来ても単に一致せず無視される
//
// currentPageKeys が空（= ANNOUNCEMENT_PAGE_KEYS に未登録のページ。404 や 500 等）の場合は
// お知らせ側の設定に関わらず常に非表示にする
const shouldShowAnnouncement = (
  targetPageKeys: readonly string[],
  currentPageKeys: readonly string[]
) =>
  currentPageKeys.length > 0 &&
  (targetPageKeys.length === 0 ||
    targetPageKeys.some((key) => currentPageKeys.includes(key)))

export const AnnouncementBanner: React.FC<Props> = ({ pageKeys }) => {
  const { data } = useQuery(AnnouncementsDocument)

  const announcements = (data?.announcements ?? []).filter((announcement) =>
    shouldShowAnnouncement(announcement.pageKeys, pageKeys)
  )

  if (announcements.length === 0) return null

  return (
    <div style={containerStyle}>
      {announcements.map((announcement) => (
        <Alert
          key={announcement.id}
          type="info"
          showIcon
          message={announcement.title}
          description={<MarkdownContent content={announcement.body} />}
          style={alertStyle}
        />
      ))}
    </div>
  )
}

// PageContainer の paddingInlinePageContainerContent(初期値40px)に合わせて左右幅を揃える
const containerStyle = { padding: '16px 40px 0' }
const alertStyle = { marginBottom: 16 }
